import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PublicSablonyFiltrDto } from '@generated/be';
import { getBasicSinglePageQueryParamList } from '@reza-ais-fe/reza-ais-fe-utils';
import { PageHeaderComponent } from '@shared/ui/components';
import { Logger, LoggerService, UIService } from '@shared/utils';
import { TableLazyLoadEvent } from 'primeng/table';
import { Router } from '@angular/router';
import { KatalogSkupinSablonOverviewFilterComponent } from './katalog-skupin-sablon-overview-filter/katalog-skupin-sablon-overview-filter.component';
import { KatalogSkupinSablonStateService } from '../../services/katalog-skupin-sablon-state.service';
import { KatalogSkupinSablonFilterFormService } from '../../services/katalog-skupin-sablon-filter-form.service';
@Component({
  selector: 'reza-katalog-skupin-sablon-main',
  standalone: true,
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  imports: [CommonModule, PageHeaderComponent, KatalogSkupinSablonOverviewFilterComponent],
  providers: [KatalogSkupinSablonFilterFormService],
})
export class KatalogSkupinSablonMainPageComponent {
  public readonly katalogSkupinSablonOverviewState = inject(KatalogSkupinSablonStateService);
  private readonly uiService = inject(UIService);
  readonly router = inject(Router);
  readonly loggerService = inject(LoggerService);

  private logger: Logger = this.loggerService.createLogger('KatalogSkupinSablonMainPageComponent');

  onLazyLoad(event: TableLazyLoadEvent) {
    const sorting: string[] = [];
    const basicSinglePageQueryParams = getBasicSinglePageQueryParamList(event, sorting);
    this.katalogSkupinSablonOverviewState.findWithParcialFilter({
      pageAndSortList: basicSinglePageQueryParams,
    });
  }

  handleSubmitFilter(filter: PublicSablonyFiltrDto) {
    this.logger.debug('handleSubmitFilter', filter);
    this.katalogSkupinSablonOverviewState.findWithNewFilter(filter);
  }

  handleClearFilter(filter: PublicSablonyFiltrDto) {
    this.logger.debug('handleClearFilter', filter);
    this.katalogSkupinSablonOverviewState.findWithClearFilter(filter);
  }
}
